<template>
  <div style="height: 100%" class="bom">
    <SplitContainer2 style="height:100%" layout="horizontal" :split_setting="0.6">
      <template #table1>
        <TableMain name="one table" ref="PreDistributionTable1" :fields="fields1" :title="table_title.title1"
          :date_picker_label="''" :query_button_label="query_lable" :show_query_container="true"
          :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false"
          :show_toolbar="true" :show_toolbar_state="false" :show_filter="true" :isBusy="isBusy"
          :table_height_adjust="-6" :show_toolbar_button="[0, 0, 1, 0, 1]"
          :hb_table_class="'hb_table_predistribution_class1'" @current_changed="current_changed"
          @state_change="state_change" @on_query="on_query" tableref="b94a8e5082464a67a2c93e98e91b25ac">
          <template #query>
            <el-date-picker class="ml-1" size="small" style="width: 220px" v-model="date_range" type="daterange"
              align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptions()">
            </el-date-picker>
            <el-input placeholder="物料编号" class="ml-1" clearable size="small" style="width: 180px"
              v-model="ItemId"></el-input>
            <el-input placeholder="物料名称" class="ml-1" clearable size="small" style="width: 180px"
              v-model="NameAlias"></el-input>
          </template>
          <template #toolbar>
            <el-button type="info" plain @click="isShowDrawer = true" class="ml-2 iconfont icon-add-new" size="mini">
              {{ $t("common.new") }}
            </el-button>

            <el-checkbox style="margin: 8px 8px" v-model="only_value1" @change="only_methods_main">仅待审批</el-checkbox>
            <el-checkbox style="margin: 8px 0" v-model="only_value2" @change="only_methods_main">仅待我审批</el-checkbox>
          </template>
          <template #operation>
            <el-popover placement="right" title="提示" width="300" trigger="hover" style="border-color: red;color:red;">
              <p>此处变更是根据选中的现有分配新增一个不同的分配！！！</p>
              <i slot="reference" class="el-icon-warning ml-2" style="font-size:18px;margin-top: 6px;"></i>
            </el-popover>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="MainSaveData"
              label="变更" class="ml-2">
            </QueryButton>
          </template>
        </TableMain>
      </template>
      <template #table2>
        <TableMain ref="PreDistributionTable2" :fields="fields2" :show_query_container="false"
          :title="table_title.title2" :date_picker_label="date_picker_label" :table_height_adjust="10"
          :show_pagination="true" :show_toolbar_state="false" :show_filter="false" :pager_count="5" :isBusy="isBusy4"
          @state_change="detail_state_change" :show_toolbar_button="[0, 0, 0, 0, 1]"
          @on_input="distribution_on_input_edit" tableref="a002700bfce64a10bef7b387de8c469d">
          <template #toolbar>
            供应商：<el-select size="small" v-model="MainSelectedAccountNumData" multiple filterable remote reserve-keyword
              collapse-tags :remote-method="MainVendersRemoteMethod" clearable @clear="MainVendersRemoteMethod('')"
              @blur="MainVendersRemoteMethod('')" placeholder="请输入供应商关键词" style="width:200px;">
              <el-option v-for="(t, k) in VendersOptions" :key="k" :label="t.label" :value="t.value"></el-option>
            </el-select>
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="MainAddVendInto"><i
                class="fa fa-plus"></i></el-button>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
              @on_query="MainSaveDataChange" label="保存" class="ml-2">
            </QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer2>
    <el-drawer :size="'70%'" :visible.sync="isShowDrawer" :direction="'rtl'" :modal="false" style="z-index: 999999;">
      <template slot="title">
        <span>新建预分配</span>
      </template>
      <SplitContainer21 style="height:100%" :layout="12">
        <template #top>
          <TableMain ref="InventPreTable2" :show_query_container="false" :show_date_picker="false"
            :fields="inventTable_fields" :table_height_adjust="8" :title="table_title.title3"
            :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false"
            :show_toolbar_state="false" :pager_count="5" :isBusy="isBusy2" :check_state="true"
            :only_text1="$t('common.pub_invent')" :hb_table_class="'hb_table_invent_pre_class2'"
            @only_methods="only_methods" tableref="f03fd947331f4952912da6d3b9363d57">
            <template #toolbar>
              销售公司：<el-select size="small" v-model="dataAreaId" filterable clearable placeholder="请选择销售公司" class="w-10">
                <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
                  :label="item.DataArea + ':' + item.CompanyName" :value="item.DataArea"></el-option>
              </el-select>
              <el-button type="primary" @click="QueryInvent" class="ml-2 iconfont icon-search" size="mini">
                {{ $t("common.query") }}
              </el-button>
            </template>
          </TableMain>
        </template>
        <template #bottom>
          <TableMain ref="InventPreTable3" :fields="distribution_fields" :show_query_container="false"
            :title="table_title.title4" :date_picker_label="date_picker_label" :table_height_adjust="2"
            :show_pagination="true" :show_toolbar_state="false" :show_filter="false" :pager_count="5" :isBusy="isBusy3"
            @state_change="new_state_change" :show_toolbar_button="[0, 0, 0, 0, 1]" @on_input="distribution_on_input" tableref="d3e5ada225b24ff38e6c0f1752af6f24">
            <template #toolbar>
              销售公司：<el-select size="small" v-model="newDataAreaId" filterable clearable placeholder="请选择销售公司"
                class="w-10">
                <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
                  :label="item.DataArea + ':' + item.CompanyName" :value="item.DataArea"></el-option>
              </el-select>
              供应商：
              <el-select size="small" v-model="SelectedAccountNumData" clearable multiple filterable reserve-keyword
                collapse-tags :filter-method="VendersRemoteMethod"
                @remove-tag="VendersRemoteMethod(SelectedAccountNumData)" @clear="VendersRemoteMethod('')"
                @focus="VendersRemoteMethod('')" @blur="VendersRemoteMethod('')" placeholder="请输入供应商关键词"
                style="width:400px;">
                <el-option v-for="(t, k) in VendersOptionsNew" :key="k" :label="t.label" :value="t.value"></el-option>
              </el-select>
              <el-button type="info" plain style="width: 55px" class="ml-2" @click="AddVendInto"><i
                  class="fa fa-plus"></i></el-button>
            </template>
            <template #operation>
              <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
                @on_query="Distribution_SaveData" :label="$t('common.save')" class="ml-2"></QueryButton>
            </template>
          </TableMain>
        </template>
      </SplitContainer21>
    </el-drawer>
  </div>
</template>

<script>
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from "../../controllers/commonController"
import * as PreDistributionController from "../../controllers/sd/PreDistributionController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as ApproveUserSettingController from "../../controllers/system/ApproveUserSettingController"
import * as localStorageMgr from "../../shared/localStorageMgr"
import QueryButton from "../components/base/QueryButton"
import SplitContainer2 from "../components/container/SplitContainer2"
import SplitContainer21 from "../components/container/SplitContainer21"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    SplitContainer2,
    SplitContainer21,
    TableMain,
    QueryButton,
    BaseModal,
  },
  data() {
    return {
      isShowDrawer: false,
      date_picker_label: "",
      date_range: [this.$date.addMonths(new Date(), -6), new Date()],
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "pre_distribution",
        title2: "pre_distribution_detail",
        title3: "table_invent",
        title4: "pre_distribution_detail",
      },
      fields1: _.cloneDeep(PreDistributionController.fields.default),
      fields2: _.cloneDeep(PreDistributionController.fields.detail),
      inventTable_fields: _.cloneDeep(SalesOrderController.fields.inventTable_fields),
      distribution_fields: _.cloneDeep(PreDistributionController.fields.detail_add),
      dataAreaId: "070",//销售公司编号
      newDataAreaId: "",//新增时的销售公司
      SelectedAccountNumData: [],//供应商编号
      SelectedAccountNumDetailData: [],//明细增加分配供应商
      MainSelectedAccountNumData: [],//供应商编号
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      isBusy4: false,
      ItemId: "",
      NameAlias: "",
      VendersOptions: [],
      VendersOptionsNew: [],
      all_role_users: [],
      only_value1: false,
      only_value2: true,
      localApprover: ""
    }
  },
  async created() {
    await this.getAllRoleUsers()

  },
  async mounted() {
    this.local_username = localStorageMgr.get(localStorageMgr.data.last_login_account)
    await this.getLocalUserApprover()
    await this.on_query(this.$refs.PreDistributionTable1.SetData)
    this.MainVendersRemoteMethod('')
    this.VendersRemoteMethod('')
  },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    async getLocalUserApprover() {
      let _params = { DocumentCreateBy: this.local_username, DocumentType: "SalesQuoteDistributionPre" }
      let rt = await ApproveUserSettingController.methods.getUserDocumentApprover(_params)
      if (rt && rt[0].length > 0 && rt[0][0])
        this.localApprover = rt[0][0].Approver
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 预分配
    async on_query(set_data, isLoading = true) {
      this.ItemId = _.trim(this.ItemId)
      this.NameAlias = _.trim(this.NameAlias)
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }
      let hasDate = true
      let p = { is_deleted: { "=": 0 } }
      if (this.ItemId != "") {
        p.ItemId = { "=": this.ItemId }
        hasDate = false
      }
      if (this.NameAlias != "") {
        p.NameAlias = { "like": "%" + this.NameAlias + "%" }
        hasDate = false
      }
      if (!_.isNull(this.date_range) && hasDate) {
        let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        p["create_at"] = { ">=": this.$date.format(this.date_range[0], "yyyy-MM-dd"), "<": _toDate }
      }
      let _result = await PreDistributionController.methods.getPreDistribution(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.cloneDeep(_result[0])
        if (this.only_value1)
          dt = _.filter(dt, { fcCheckDocumentApproved: false })

        _.each(dt, (t) => {
          this.getApprover(t)
        })
        if (this.only_value2) {
          dt = _.filter(dt, (t) => {
            return t.fcGetDocumentApprover && t.fcGetDocumentApprover.indexOf(this.local_username) > -1 &&
              !t.fcCheckDocumentApproved
          })
        }
        set_data(_.orderBy(dt, ["id"], ["desc"]))
      }

      this.$refs.PreDistributionTable2.SetData([])
      this.isBusy = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetDocumentApprover",
        "fcGetDocumentApprover",
        t.fcCheckDocumentApproved,
        true
      )
    },
    current_changed(old, current) {
      if (current) {
        let fm = _.find(this.fields2, { key: "DistributionRate" })
        fm.editable = !current.fcCheckDocumentApproved
        this.getDetail(current)
      }
    },
    async only_methods_main() {
      await this.on_query(this.$refs.PreDistributionTable1.SetData, true)
    },
    async getDetail(t, isLoading = true) {
      if (isLoading)
        this.isBusy4 = true
      let _result = await PreDistributionController.methods.getPreDistributionDetail({ PreDistributionId: t.id })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.PreDistributionTable2.SetData(_.orderBy(_result[0], ["id"], ["asc"]))
      }
      this.isBusy4 = false
    },
    AddVendIntoDetail() {
      let newItems = []
      let pre_m = this.$refs.PreDistributionTable1.GetCurrentItem()
      if (!pre_m) {
        this.msgToasts("请选择预分配主档！", "info")
        return
      }
      _.each(this.SelectedAccountNumDetailData, (num) => {
        let m = {}
        m.id = ""
        m.AccountNum = num
        let vm = _.find(this.$store.state.biz_data.baseData.Vender, { AccountNum: num })
        m.AccountName = vm.SEI_Name
        m.PreDistributionId = pre_m.id
        if (_.findIndex(this.$refs.PreDistributionTable2.my_data, { AccountNum: num }) < 0) {
          newItems.push(m)
        }
      })
      this.$refs.PreDistributionTable2.AppendItems(newItems)
    },
    distribution_on_input_edit(data) {
      if (data.field.key == "DistributionRate") {
        let lt = _.each(_.cloneDeep(this.$refs.PreDistributionTable2.my_data), (t) => {
          if (!t.DistributionRate) {
            t.DistributionRate = 0
          }
          else {
            t.DistributionRate = parseFloat(t.DistributionRate)
          }
        })
        let total_rate = _.sumBy(lt, "DistributionRate")
        if (total_rate > 100) {
          let _rate = 100 - (total_rate - data.item.DistributionRate)
          data.item.DistributionRate = _rate
        }
      }
    },

    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let v = await this.msgModal(this.$t("notify.is_continue"))
      if (!v) { cb(false); return }
      let p = { delete: [] }, msg = ""
      if (data.state === "deleted") {
        let is_del_ok = _.findIndex(data.selected_items, { fcCheckDocumentApproved: true }) > -1
        if (is_del_ok) {
          this.msgToasts("已审批数据不能被删除！", "info")
          cb(false)
          return
        }
        p.delete = data.selected_items
      }
      else if (data.state == "approved" || data.state == "unapproved") {
        let dt = _.filter(data.selected_items, (t) => { return t.fcCheckDocumentApproved == !(data.state == "approved") })
        if (dt.length == 0) { cb(false); return }
        ///检查是否有该权限
        let check_ap_res = []
        let _check_ap_params = {
          list: dt,
          DocumentType: "SalesQuoteDistributionPre",
          approve_type: "",
          isNotCheckPrivilage: data.state == "approved" ? false : true,
          action_state: data.state == "approved",
        }
        check_ap_res = await commonController.methods.checkApprovePrivilige(_check_ap_params, this)
        if (check_ap_res.notPriviligeIdList.length > 0 || check_ap_res.approveStatusIdList.length == 0) {
          this.msgToasts("抱歉，暂无审批权限！", "error")
          cb(false)
          return
        }

        p.approved = {}
        p.approved.data = dt
        p.approved.local_username = this.$global.global_data.local_username
        p.approved.approveStatusIdList = check_ap_res.approveStatusIdList
        if (data.state == "approved") {
          let _reSetData = _.map(
            data.selected_items,
            (t) => { return { dataAreaId: t.dataAreaId, ItemId: t.ItemId, status: 0, DocumentType: "SalesQuoteDistributionPre" } }
          )
          p.approved.reSetStatusPreDistributionList = _.uniqWith(_reSetData, _.isEqual)
        }
      }
      let rt = await PreDistributionController.methods.savePreDistribution(p)
      if (rt) {
        if (data.state === "deleted") {
          this.$refs.PreDistributionTable1.RemoveItems(data.selected_items)
          this.$refs.PreDistributionTable2.SetData([])
        }
        else
          await this.on_query(this.$refs.PreDistributionTable1.SetData, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(false)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    async Detail_SaveData(cb) {
      //数据验证
      let msg = "", p = { add: [], edit: [] }
      let detail_data = this.$refs.PreDistributionTable2.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }

      let require_fileds = _.map(_.filter(this.fields2, { required: true }), (t) => { return t })
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        for (var i in require_fileds) {
          let fm = require_fileds[i]
          if (msg == "" && m[fm.key] == "") {
            msg = fm.label + "不能为空！"
          }
        }
        if (m.id == "") {
          delete m.id
          p.add.push(m)
        }
        else p.edit.push(m)
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      let rt = await PreDistributionController.methods.savePreDistributionDetail(p)
      if (rt) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
        let pre_m = this.$refs.PreDistributionTable1.GetCurrentItem()
        await this.getDetail(pre_m, false)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    async detail_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state === "deleted") {
        let main = this.$refs.PreDistributionTable1.GetCurrentItem()
        if (main.fcCheckDocumentApproved) {
          this.msgToasts("已审批数据，不能被修改!", "info")
          cb(false)
          return
        }
        let v = await this.msgModal(this.$t("notify.is_deleted"))
        if (v) {
          let p = { delete: data.selected_items }
          let rt = await PreDistributionController.methods.savePreDistributionDetail(p)
          if (rt) {
            this.$refs.PreDistributionTable2.RemoveItems(data.selected_items)
            this.msgToasts(this.$t("notify.action_successfully"), "success")
            cb(false)
          }
          else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
            cb(false)
          }
        }
      }
    },
    MainVendersRemoteMethod(query) {
      let dt = this.$store.state.biz_data.baseData.Vender
      if (query != "") {
        dt = _.filter(dt, (t) => {
          if (_.includes(t.AccountNum, query) || _.includes(t.SEI_Name, query))
            return { value: t.AccountNum, label: t.AccountNum + ":" + t.SEI_Name }
        })
      }
      dt = _.map(_.slice(dt, 0, 100), (t) => {
        return { value: t.AccountNum, label: t.AccountNum + ":" + t.SEI_Name }
      })

      this.VendersOptions = dt
      if (this.MainSelectedAccountNumData.length > 0) {
        for (var i in this.MainSelectedAccountNumData) {
          if (!_.some(this.VendersOptions, { value: this.MainSelectedAccountNumData[i] })) {
            let m = _.find(this.$store.state.biz_data.baseData.Vender, { AccountNum: this.MainSelectedAccountNumData[i] })
            this.VendersOptions.unshift({ value: m.AccountNum, label: m.AccountNum + ":" + m.SEI_Name })
          }
        }
      }
    },
    ///物料下拉
    VendersRemoteMethod(query) {
      let dt = this.$store.state.biz_data.baseData.Vender
      if (query != "") {
        dt = _.filter(dt, (t) => {
          if (_.includes(t.AccountNum, query) || _.includes(t.SEI_Name, query))
            return { value: t.AccountNum, label: t.AccountNum + ":" + t.SEI_Name }
        })
      }
      dt = _.map(_.slice(dt, 0, 100), (t) => {
        return { value: t.AccountNum, label: t.AccountNum + ":" + t.SEI_Name }
      })

      this.VendersOptionsNew = _.cloneDeep(dt)
      console.log(this.SelectedAccountNumData)
      if (this.SelectedAccountNumData.length > 0) {
        for (var i in this.SelectedAccountNumData) {
          if (!_.some(this.VendersOptionsNew, { value: this.SelectedAccountNumData[i] })) {
            let m = _.find(this.$store.state.biz_data.baseData.Vender, { AccountNum: this.SelectedAccountNumData[i] })
            this.VendersOptionsNew.unshift({ value: m.AccountNum, label: m.AccountNum + ":" + m.SEI_Name })
          }
        }
      }
    },
    async getInventData(isPublic) {
      this.isBusy2 = true
      let _p = {}
      _p.dataAreaId = this.dataAreaId
      _p.publicItem = isPublic == true ? 1 : 0
      let _result = await InventTableController.methods.getSOInventData(_p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.InventPreTable2.SetData(
          _.orderBy(_result[0], ["createdDateTime"], ["desc"])
        )
      }
      this.isBusy2 = false
    },
    async only_methods(isAllCust, isPublic) {
      await this.getInventData(isPublic)
    },
    //查询物料
    async QueryInvent() {
      await this.getInventData(this.$refs.InventPreTable2.only_value1)
    },
    //#endregion

    //#region 新建分配相关
    AddVendInto() {
      let newItems = []
      let invent_m = this.$refs.InventPreTable2.GetCurrentItem()
      if (!invent_m) {
        this.msgToasts("请选择物料！", "info")
        return
      }
      if (this.newDataAreaId == "") {
        this.msgToasts("请选择销售公司！", "info")
        return
      }
      _.each(this.SelectedAccountNumData, (num) => {
        let m = {}
        m.id = ""
        m.ItemId = invent_m.ItemId
        m.NameAlias = invent_m.NameAlias
        m.AccountNum = num
        let vm = _.find(this.$store.state.biz_data.baseData.Vender, { AccountNum: num })
        m.AccountName = vm.SEI_Name
        m.dataAreaId = this.newDataAreaId
        m.PreDistributionId = ""
        m.Description = ""
        if (_.findIndex(this.$refs.InventPreTable3.my_data, { AccountNum: num }) < 0) {
          newItems.push(m)
        }
      })
      this.$refs.InventPreTable3.AppendItems(newItems)
    },
    ///分配状态切换
    new_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state === "deleted") {
        this.$refs.InventPreTable3.RemoveItems(data.selected_items)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      }
    },
    ///明细行输入事件
    distribution_on_input(data) {
      if (data.field.key == "DistributionRate") {
        let lt = _.each(_.cloneDeep(this.$refs.InventPreTable3.my_data), (t) => {
          if (!t.DistributionRate) {
            t.DistributionRate = 0
          }
          else {
            t.DistributionRate = parseFloat(t.DistributionRate)
          }
        })
        let total_rate = _.sumBy(lt, "DistributionRate")
        if (total_rate > 100) {
          let _rate = 100 - (total_rate - data.item.DistributionRate)
          data.item.DistributionRate = _rate
        }
      }
    },
    ///保存分配详情
    async Distribution_SaveData(cb) {
      //数据验证
      let msg = "", pm = {}, p = { add: [], edit: [] }, items = []
      let detail_data = this.$refs.InventPreTable3.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }

      let require_fileds = _.map(_.filter(this.distribution_fields, { required: true }), (t) => { return t })
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        for (var i in require_fileds) {
          let fm = require_fileds[i]
          if (msg == "" && m[fm.key] == "") {
            msg = fm.label + "不能为空！"
          }
        }
        pm = { ItemId: m.ItemId, NameAlias: m.NameAlias, dataAreaId: m.dataAreaId }
        delete m.id
        delete m.ItemId
        delete m.NameAlias
        delete m.dataAreaId
        items.push(m)
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      p.add.push(pm)
      p.documentCreateByUsername = this.$global.global_data.local_username
      p.IsDefaultApproved = 0
      if (this.$global.global_data.local_username == this.localApprover)
        p.IsDefaultApproved = 1

      let rt = await PreDistributionController.methods.savePreDistribution(p, items)
      if (rt) {
        await this.on_query(this.$refs.PreDistributionTable1.SetData, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
        this.SelectedAccountNumData = []
        this.$refs.InventPreTable3.SetData([])
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //#endregion

    MainAddVendInto() {
      let newItems = []
      let invent_m = this.$refs.PreDistributionTable1.GetCurrentItem()
      if (!invent_m) {
        this.msgToasts("请选择物料！", "info")
        return
      }
      _.each(this.MainSelectedAccountNumData, (num) => {
        let m = {}
        m.id = ""
        m.AccountNum = num
        let vm = _.find(this.$store.state.biz_data.baseData.Vender, { AccountNum: num })
        m.AccountName = vm.SEI_Name
        m.PreDistributionId = invent_m.id
        if (_.findIndex(this.$refs.PreDistributionTable2.my_data, { AccountNum: num }) < 0) {
          newItems.push(m)
        }
      })
      this.$refs.PreDistributionTable2.AppendItems(newItems)
    },
    async MainSaveData(cb) {
      let main = this.$refs.PreDistributionTable1.GetCurrentItem()
      if (!main) {
        this.msgToasts("请选择需要变更的行!", "info")
        cb(null)
        return
      }
      if (!main.fcCheckDocumentApproved) {
        this.msgToasts("未审批数据，不能被变更!", "info")
        cb(null)
        return
      }
      //数据验证
      let msg = "", pm = {}, p = { add: [], edit: [] }, items = []
      let detail_data = this.$refs.PreDistributionTable2.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }

      let require_fileds = _.map(_.filter(this.distribution_fields, { required: true }), (t) => { return t })
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        for (var i in require_fileds) {
          let fm = require_fileds[i]
          if (msg == "" && m[fm.key] == "") {
            msg = fm.label + "不能为空！"
          }
        }
        pm = { ItemId: main.ItemId, NameAlias: main.NameAlias, dataAreaId: main.dataAreaId }
        delete m.id
        delete m.ItemId
        delete m.NameAlias
        delete m.dataAreaId
        items.push(m)
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      p.add.push(pm)
      p.documentCreateByUsername = this.$global.global_data.local_username
      p.IsDefaultApproved = 0
      if (this.$global.global_data.local_username == this.localApprover)
        p.IsDefaultApproved = 1

      let rt = await PreDistributionController.methods.savePreDistribution(p, items)
      if (rt) {
        await this.on_query(this.$refs.PreDistributionTable1.SetData, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
        this.SelectedAccountNumData = []
        this.$refs.InventPreTable3.SetData([])
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    async MainSaveDataChange(cb) {
      let main = this.$refs.PreDistributionTable1.GetCurrentItem()
      if (!main) {
        this.msgToasts("请选择需要变更的行!", "info")
        cb(null)
        return
      }
      if (main.fcCheckDocumentApproved) {
        this.msgToasts("已审批数据，不能被修改!", "info")
        cb(null)
        return
      }
      //数据验证
      let msg = "", p = { add: [], edit: [] }
      let detail_data = this.$refs.PreDistributionTable2.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }

      let require_fileds = _.map(_.filter(this.distribution_fields, { required: true }), (t) => { return t })
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        for (var i in require_fileds) {
          let fm = require_fileds[i]
          if (msg == "" && m[fm.key] == "") {
            msg = fm.label + "不能为空！"
          }
        }
        if (m.id == "") {
          delete m.id
          p.add.push(m)
        }
        else p.edit.push(m)
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }

      let rt = await PreDistributionController.methods.savePreDistributionDetail(p)
      if (rt) {
        await this.getDetail(main, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
        this.MainSelectedAccountNumData = []
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    }
  },
}
</script>
<style>
.hb_table_predistribution_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 70rem;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.bom .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #1138e1b3;
  color: #fff;
}

.hb_table_invent_pre_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 80rem;
}

.bom .el-card__body,
.el-main {
  padding: 0px;
}

.bom .el-drawer__header {
  font-size: 1.1rem;
  color: black;
  padding-left: 0.5rem;
  margin-bottom: 16px;
}
</style>
